import { render, staticRenderFns } from "./PanelAnalista.vue?vue&type=template&id=154aea7d&scoped=true"
import script from "./PanelAnalista.vue?vue&type=script&lang=js"
export * from "./PanelAnalista.vue?vue&type=script&lang=js"
import style0 from "./PanelAnalista.vue?vue&type=style&index=0&id=154aea7d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154aea7d",
  null
  
)

export default component.exports